import { i18n } from '@factorin/container.macro';


export const errorFormatter = key => i18n.t(`apiErrors:${key}`);
